module.exports = __webpack_public_path__ + "static/media/wps_nav_logo.3e312a96.svg";